<template>
    <div>
        <div class="row">
            <div class="col">
                <h4>Are you looking to purchase another property as well?</h4>
            </div>
        </div>
        <div class="row">
            <div class="col button-row">
                <b-button class="button yes-no" :class="[{'active': buyQuestion === 'YES'}]" pill variant="outline-secondary" :pressed="isSelected('YES')"
                          @click="updateBuyQuestion('YES')">Yes
                </b-button>
                <b-button class="button yes-no" :class="[{'active': buyQuestion === 'NO'}]" pill variant="outline-secondary" :pressed="isSelected('NO')"
                          @click="updateBuyQuestion('NO')">No
                </b-button>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="contain">
                <div v-show="buyQuestion === 'YES'">

                    <h4>Enter the city where you would like to purchase</h4>

                    <map-box-textbox 
                        ref="autocomplete"
                        :value="buyLocation"
                        :search-type="'place'"
                        @on-location-selection="locationSelected"
                        @on-error="onError"
                        @on-blur="onBlur" 
                    />
                    <small class="mt-2">
                        Please enter a city and state
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {saveField} from "@/services/apiService";
    import MapBoxTextbox from './input/MapBoxTextbox.vue';
    import { getMapBoxSelections } from '@/utils';

    export default {
        name: "BuyQuestion",
        components: {
            MapBoxTextbox
        },
        data() {
            return {
                buyQuestion: undefined,
                buyLocation: undefined,
                latitude: undefined,
                longitude: undefined
            }
        },
        methods: {
            updateBuyQuestion: function (value) {
                this.buyQuestion = value;
                this.$emit('update-buyer-ques', this.buyQuestion);
                saveField('Seller_Buyer_or_Both', this.buyQuestion);
                if (value === 'NO') this.$emit('go-to-next-step');
            },
            isSelected: function (value) {
                if (!this.isEmpty(this.value)) {
                    return this.buyQuestion === value;
                }
            },
            locationSelected: function(item) {
                if (typeof item.place_name !== 'undefined') {
                    const mapBoxInfo = getMapBoxSelections(item);
                    this.buyLocation = item.place_name
                    this.latitude = item.center[1]
                    this.longitude = item.center[0]
                    const buyInfo = {
                        place: item.place_name,
                        city: mapBoxInfo.city,
                        state: mapBoxInfo.state,
                        latitude: item.center[1],
                        longitude: item.center[0]
                    }
                    this.$emit('update-buyer-loc', buyInfo);
                    saveField('Buy_Location', item.place_name);
                }
            },
            onError: function(text) {
                this.$emit('input', text);
            },
            onBlur: function() {
                if (!this.buyLocation) {
                    this.$emit('update-buyer-loc', { place: this.$refs.autocomplete.$refs.tbxMapBox.value, latitude: this.latitude, longitude: this.longitude });    
                }                   
            }
        }
    }
</script>

<style scoped>
    .button-row {
        padding: 5px;
    }

    .button {
        margin: auto;
        left: 0;
        right: 0;
        padding: 10px;
        width: 175px;
    }
    .yes-no{
        margin: 0 0 10px 10px;
    }
</style>
